import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface InferenceTriple {
  source: string;
  relationship: string;
  target: string;
  document_source: string;
}

export interface InferenceResult {
  topic: string;
  inference_type: string;
  inference: string;
  supporting_facts: InferenceTriple[];
  confidence: number;
  severity: 'low' | 'medium' | 'high' | 'critical';
  recommended_action: string;
}

export interface InferenceResponse {
  hasResult: boolean;
  result: InferenceResult[];
}

export interface InferenceListResponse {
  hasResult: boolean;
  data: InferenceResult[];
}

@Injectable({ providedIn: 'root' })
export class InferenceService {
  private http = inject(HttpClient);
  private base = environment.apiUrl;

  generate(documentNames: string[] | null): Observable<InferenceResponse> {
    return this.http.post<InferenceResponse>(`${this.base}/inference/generate`, {
      documentNames: documentNames && documentNames.length > 0 ? documentNames : null
    });
  }

  getAll(): Observable<InferenceListResponse> {
    return this.http.get<InferenceListResponse>(`${this.base}/inference`);
  }
}
